import React from "react";
import { DEALERSHIP } from "../data/dealership";

const officialLinks = [
  ["Official website", DEALERSHIP.website],
  ["New vehicles", DEALERSHIP.newVehicles],
  ["Used vehicles", DEALERSHIP.usedVehicles],
  ["Service department", DEALERSHIP.service],
  ["Order parts", DEALERSHIP.parts],
  ["Finance center", DEALERSHIP.finance],
  ["Value your trade", DEALERSHIP.tradeIn],
  ["Contact page", DEALERSHIP.contact],
];

function DealerResourceSummary({ compact = false }) {
  return (
    <section className="mt-4" aria-labelledby="dealer-resource-heading">
      <h4 id="dealer-resource-heading">Findlay Chrysler Dodge Jeep Ram Details</h4>
      <p className="small text-muted">
        Independent consumer resource. Official dealership contact and inventory
        links are provided for verification and convenience.
      </p>
      <ul>
        <li>
          Address: {DEALERSHIP.address}
        </li>
        <li>
          Sales, service, and parts phone: {DEALERSHIP.phone}
        </li>
        <li>
          Ohio dealer permit: {DEALERSHIP.dealerPermit}
        </li>
        {!compact ? (
          <li>
            Local context: {DEALERSHIP.makes.join(", ")} dealer serving{" "}
            {DEALERSHIP.nearbyMarkets.join(", ")} and Ohio shoppers.
          </li>
        ) : null}
      </ul>
      <div className="mt-3">
        <h5 className="h6">Official Links</h5>
        <ul>
          {officialLinks.map(([label, href]) => (
            <li key={href}>
              <a href={href} target="_blank" rel="noreferrer">
                {label}
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}

export default DealerResourceSummary;
